import type { FC } from 'react';
import React, { useState, useCallback } from 'react';

import { Box } from '@atlaskit/primitives/compiled';
import { IconButton } from '@atlaskit/button/new';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';
import type { TriggerProps } from '@atlaskit/popup';

import { useChoreographerAssets } from '@confluence/choreographer-services';

type EndOfPageCardInfoPopupProps = {
	setIsHoveringInfoIcon?: (isOpen: boolean) => void;
	onMouseLeaveIcon?: () => void;
	onMouseEnterIcon?: () => void;
};

export const EndOfPageCardInfoPopup: FC<EndOfPageCardInfoPopupProps> = ({
	setIsHoveringInfoIcon,
	onMouseLeaveIcon,
	onMouseEnterIcon,
}) => {
	const { Popup } = useChoreographerAssets();
	const [isOpen, setIsOpen] = useState(false);

	const onInfoClick = useCallback(() => {
		setIsOpen(true);
		setIsHoveringInfoIcon?.(true);
	}, [setIsHoveringInfoIcon]);

	const onPopupClose = useCallback(() => {
		setIsOpen(false);
		setIsHoveringInfoIcon?.(false);
	}, [setIsHoveringInfoIcon]);

	const onTriggerEnter = useCallback(() => {
		setIsHoveringInfoIcon?.(true);
		onMouseEnterIcon?.();
	}, [setIsHoveringInfoIcon, onMouseEnterIcon]);

	const onTriggerLeave = useCallback(() => {
		if (isOpen) return;
		setIsHoveringInfoIcon?.(false);
		onMouseLeaveIcon?.();
	}, [isOpen, setIsHoveringInfoIcon, onMouseLeaveIcon]);

	return (
		<Popup
			shouldRenderToParent
			onClose={onPopupClose}
			content={() => <Box>Here is some text</Box>}
			isOpen={isOpen}
			placement="top"
			trigger={(triggerProps: TriggerProps) => (
				<Box onMouseEnter={onTriggerEnter} onMouseLeave={onTriggerLeave}>
					<IconButton
						appearance="subtle"
						onClick={onInfoClick}
						isSelected={isOpen}
						testId="eop-card-info-button"
						icon={InformationCircleIcon}
						label="label"
						{...triggerProps}
					/>
				</Box>
			)}
		/>
	);
};
